import React from 'react'

import HomeRender from './HomeRender'

function Home () {
  return (
    <HomeRender />
  )
}

export default Home
